import { type ReactElement } from 'react'
import useSupplierTabs from '../hooks/useSupplierTabs'
import MaDetailsTabs from '../../common/components/MaDetailsTabs'
import ReactGA from 'react-ga4'
import { useParams } from 'react-router'
import { Container } from 'react-bootstrap'
import SelectSupplier from './SelectSupplier'
import SuppliersHeader from './SuppliersHeader'
import styles from '../assets/scss/Suppliers.module.scss'
import classNames from 'classnames'
import FormDisabledContext from '../../common/components/FormDisabledContext'
import UnsavedChangesConfirm from '../../common/components/UnsavedChangesConfirm'
import { t } from 'i18next'
import { getLocation } from '../../common/utils/location'

function Suppliers (): ReactElement {
  const { supplierId } = useParams()
  const { supplierName, tabs, isFormDisabled, isDirty } =
    useSupplierTabs(supplierId)

  const activeTab = getLocation().hash.substring(1) || tabs[0].key

  const setActiveTab = (tab: string): void => {
    ReactGA.event('close_component', {
      component_type: 'tab',
      component_id: 'supplier.' + activeTab
    })

    if (tab != null) {
      ReactGA.event('open_component', {
        component_type: 'tab',
        component_id: 'supplier.' + tab
      })
    }

    getLocation().hash = tab ?? ''
  }

  return (
    <Container
      fluid="auto"
      className={classNames('ma-page', styles['suppliers-page'])}
    >
      <SuppliersHeader supplierName={supplierName} />

      {supplierId ? (
        <>
          <FormDisabledContext.Provider value={isFormDisabled}>
            <MaDetailsTabs
              tabs={tabs}
              activeTab={activeTab}
              onSelectTab={setActiveTab}
            />
          </FormDisabledContext.Provider>
        </>
      ) : (
        <SelectSupplier />
      )}

      <UnsavedChangesConfirm
        unsavedChanges={isDirty}
        message={t('unsaved_changes.message')}
        confirmLabel={t('unsaved_changes.confirm')}
      />
    </Container>
  )
}

export default Suppliers
